import React from 'react';
import { AudioVersion } from '../../types';
import './VersionSelector.css';

interface VersionSelectorProps {
  hasSeriousVersion: boolean;
  hasDiscussionVersion: boolean;
  currentVersion: AudioVersion;
  onVersionChange: (version: AudioVersion) => void;
}

const VersionSelector: React.FC<VersionSelectorProps> = ({
  hasSeriousVersion,
  hasDiscussionVersion,
  currentVersion,
  onVersionChange,
}) => {
  if (!hasSeriousVersion && !hasDiscussionVersion) return null;
  if (hasSeriousVersion && !hasDiscussionVersion) return null;
  if (!hasSeriousVersion && hasDiscussionVersion) return null;

  return (
    <div className="version-selector">
      <div className="version-toggle">
        <button
          className={`version-btn ${currentVersion === 'serious' ? 'active' : ''} ${!hasSeriousVersion ? 'disabled' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            hasSeriousVersion && onVersionChange('serious');
          }}
          disabled={!hasSeriousVersion}
        >
          <span className="version-icon">🎓</span>
          <span className="version-label">Version Sérieuse</span>
        </button>
        
        <div className="toggle-slider" data-active={currentVersion}></div>
        
        <button
          className={`version-btn ${currentVersion === 'discussion' ? 'active' : ''} ${!hasDiscussionVersion ? 'disabled' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            hasDiscussionVersion && onVersionChange('discussion');
          }}
          disabled={!hasDiscussionVersion}
        >
          <span className="version-icon">💬</span>
          <span className="version-label">Version Discussion</span>
        </button>
      </div>
    </div>
  );
};

export default VersionSelector;
